import { Injectable } from '@angular/core';
import { ProfileViewSelection } from '../interfaces/profile-view-selection.interface';
import { UserInfoService } from 'src/app/angular-elements/shared/services/user-info.service';
import { USER_ROLE } from '@ptl/account-management';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PostLoginService {

  public sortedRoleSelections$ = new BehaviorSubject<ProfileViewSelection[]>([]);

  private selections: ProfileViewSelection[];

  constructor(
    private userInfoService: UserInfoService
  ) { }

  setProfileViewSelection(selections: ProfileViewSelection[]) {
    this.selections = selections;
    this.sortedRoleSelections$.next(this.getSortedSelections());
  }

  private getSortedSelections() {
    return this.selections
    .sort((a, b) => a.order - b.order)
    .filter(view => view.applicableRoles.includes(this.userInfoService.getLoggedInUserRole()))
  }
}
